import React from 'react';
import DatasetCatalogueTabList from './DatasetCatalogueTabFieldList';
import CatalogueFieldListStatusDates from './CatalogueFieldListStatusDates';
import DatasetCatalogueAccordionFieldList from './DatasetCatalogueAccordionFieldList';

const DatasetCatalogueRight = ({
  asTab,
  category,
  code,
  direction,
  index = 0,
  panel = 'right',
  url,
}) => {
  const Component = asTab ? DatasetCatalogueTabList : DatasetCatalogueAccordionFieldList;
  return (
    <Component
      category={category}
      code={code}
      direction={direction}
      index={index}
      panel={panel}
      section="third"
      url={url}
    >
      <CatalogueFieldListStatusDates code={code} category={category} />
    </Component>
  );
};

export default DatasetCatalogueRight;
